import { Controller } from "@hotwired/stimulus";

// Refuses an oversized file before htmx uploads it, so the user hears about the
// limit at once instead of after the whole file has gone up. Bound to
// htmx:beforeRequest, htmx's own cancel point, rather than change, which htmx
// also listens for. The server keeps its own check; this only saves the trip.
export default class extends Controller {
  static targets = ["input", "error"];
  static values = { max: Number, label: String };

  check(event) {
    this.errorTarget.classList.add("d-none");

    const file = this.inputTarget.files[0];
    if (!file || file.size <= this.maxValue) return;

    event.preventDefault();
    this.errorTarget.textContent = `${file.name} is larger than ${this.labelValue}.`;
    this.errorTarget.classList.remove("d-none");
    // Cleared so choosing the same file again still fires change.
    this.inputTarget.value = "";
  }
}
